import React, { FC } from 'react';
import { Control, Controller, FieldErrors } from 'react-hook-form';

import { ButtonToggles } from '@eika/radio-button';

import { KjoennWeb } from '../../generated-types';
import { useTranslation } from '../../translations';
import { BarnFormData } from './barn';

interface Props {
    index: number;
    control: Control<BarnFormData>;
    errors: FieldErrors<BarnFormData>;
}

const Kjoenn: FC<Props> = ({ index, control, errors }) => {
    const { barn, validationMessage } = useTranslation();

    return (
        <Controller
            name={`barn.${index}.kjoenn` as const}
            control={control}
            rules={{
                validate: { ikkeValgt: (value: KjoennWeb) => value !== KjoennWeb.IKKE_VALGT },
            }}
            render={({ field: { onChange, value } }) => (
                <ButtonToggles
                    label={barn.labelKjoenn}
                    data-track-id="kreditt-boliglaan-barn-valg-barn-kjoenn"
                    data-track-linkname={value}
                    selectedOption={value}
                    onChange={(value) => onChange(value as KjoennWeb)}
                    options={[
                        { label: barn.togglesGutt, value: KjoennWeb.GUTT },
                        { label: barn.togglesJente, value: KjoennWeb.JENTE },
                    ]}
                    errorMessage={
                        errors.barn?.[index]?.kjoenn?.type === 'ikkeValgt' ? `${validationMessage.requiredChoose}` : ''
                    }
                />
            )}
        />
    );
};

export default Kjoenn;
